import React from 'react';
import { useTranslation } from 'react-i18next'; // For language handling
import { Link } from 'react-router-dom'; // Import Link from react-router-dom

import nvn from '../assets/images/nvn1.png'


function NVN() {
  const { t } = useTranslation(); // Hook for translation

  return (
    <div >
    {/* Hero Section */}
    <div className="hero-banner">
      <div className="hero-content" >
        <h1 style={{ color: 'black' }}>{t('nvn_title')}</h1>
        
      </div>
      
    </div>
    
    

    {/* Content Section */}
    <div className="hero-banner" style={{ backgroundColor: 'white' }}>
        <div className="hero-content">
        <p style={{ textAlign: 'justify' }}>{t('NVN_P1')}</p>

          <p style={{ textAlign: 'justify' }}>{t('NVN_P11')}
          <ul>
          <li style={{ textAlign: 'justify' }}>{t('NVN_P1_1')}</li>
          <li style={{ textAlign: 'justify' }}>{t('NVN_P1_2')}</li>
          <li style={{ textAlign: 'justify' }}>{t('NVN_P1_3')}</li>
          <li style={{ textAlign: 'justify' }}>{t('NVN_P1_4')}</li>
          <li style={{ textAlign: 'justify' }}>{t('NVN_P1_5')}</li>
          <li style={{ textAlign: 'justify' }}>{t('NVN_P1_6')}</li>
          <li style={{ textAlign: 'justify' }}>{t('NVN_P1_7')}</li>
          </ul></p>

          <p style={{ textAlign: 'justify' }}>{t('NVN_P2')}
          <ul>
          <li style={{ textAlign: 'justify' }}>{t('NVN_P2_1')}</li>
          <li style={{ textAlign: 'justify' }}>{t('NVN_P2_2')}</li>
          <li style={{ textAlign: 'justify' }}>{t('NVN_P2_3')}</li>
          <li style={{ textAlign: 'justify' }}>{t('NVN_P2_4')}</li>
          <li style={{ textAlign: 'justify' }}>{t('NVN_P2_5')}</li>
          <li style={{ textAlign: 'justify' }}>{t('NVN_P2_6')}</li>
          <li style={{ textAlign: 'justify' }}>{t('NVN_P2_7')}</li>
          <li style={{ textAlign: 'justify' }}>{t('NVN_P2_8')}</li>
          </ul></p>
          <p style={{ textAlign: 'justify' }}>{t('NVN_P3')} <a href={t('NTGN-url')} target="_blank" rel="noopener noreferrer" style={{textDecoration:'none'}}>{t('national_tide_gauge_network')}</a></p>

          <p style={{ textAlign: 'justify' }}><Link to="https://apps.geoportal.sa/PDFs/Geodesy/nvn/GASGI_NVN%20locations%20(approximate).kmz" target='balnk'>{t('NVN_P3_URL')}</Link></p>
          <img src={nvn} alt="Arrow Icon" style={{ width: '100%', height: 'auto', maxWidth: '600px' }} />
          <br /><br></br>



          <p style={{ textAlign: 'justify' }}><b>{t('NVN_P4')}</b>
          <ul>
          <li>{t('NGN_P4_1')} </li>
          <li>{t('NGN_P4_2')} </li>
          <li>{t('NGN_P4_31')} <a
              href={`mailto:${t('email_address')}`}
              target="_blank"
              rel="noopener noreferrer"
             
            > info@geosa.gov.sa</a> {t('NGN_P4_32')}</li>

            
            </ul></p>
          
          
          
          
          </div>
          
      </div>
      <div className="cards-space" style={{height:"40px"}}></div>
      
      
 
    
    </div>
);
}

export default NVN;
